/** @format */

import convertFileToB64 from '@common/application/helpers/convertFileToB64';
import axios from 'axios';

export class Site {
  id: number;
  accountId: number;
  name: string;
  addressLines: Array<string>;
  locality: string;
  region: string;
  postcode: string;
  countryId: string;
  siteAccountNumber: string;
  createdAt: string;
  updatedAt: string;
  deletedAt: string;

  constructor(accountId: number, name: string, addressLines: Array<string>, locality: string, region: string, postcode: string, countryId: string, siteAccountNumber: string) {
    this.accountId = accountId;
    this.name = name;
    this.addressLines = addressLines;
    this.locality = locality;
    this.region = region;
    this.postcode = postcode;
    this.countryId = countryId;
    this.siteAccountNumber = siteAccountNumber;
  }

  static list(
    query,
    sort,
    queryOpts?: Record<string, unknown>,
    size?: number,
    pit?: { id: string },
    search_after?: Array<unknown>,
  ): Promise<{ payload: Array<{ _source: Site; sort }>; last_page: number; total: { value: number } }> {
    // Ensure this code is not ran by SSR!
    if (typeof window !== 'undefined') {
      return axios
        .get(`${window.location.protocol}//${window.location.host}/api/v1/sites`, {
          params: {
            sequence_id: 1,
            pit,
            query,
            queryOpts: JSON.stringify(queryOpts ?? { deleted: false }),
            sort: JSON.stringify(sort),
            search_after: JSON.stringify(search_after),
            size,
          },
        })
        .then((res) => ({ ...res.data }));
    }
    throw new Error();
  }

  static autocomplete(query, config, accountId?: number) {
    if (typeof window !== 'undefined') {
      return axios
        .get(`${window.location.protocol}//${window.location.host}/api/v1/sites/search`, {
          params: {
            sequence_id: 1,
            accountId,
            query,
          },
        })
        .then((res) => ({ ...res.data }));
    }
    throw new Error();
  }

  static get(id: number): Promise<{ message: string; paginated: boolean; payload: Site }> {
    return axios.get(`${window.location.protocol}//${window.location.host}/api/v1/sites/${id}`).then((res) => ({ ...res.data }));
  }

  static delete(id: number): Promise<Record<string, unknown>> {
    return axios.delete(`${window.location.protocol}//${window.location.host}/api/v1/sites/${id}`).then((res) => ({ ...res.data }));
  }

  static undelete(id: number): Promise<Record<string, unknown>> {
    return axios.post(`${window.location.protocol}//${window.location.host}/api/v1/sites/${id}/undelete`).then((res) => ({ ...res.data }));
  }

  static update(
    updatedSite: {
      accountId: number;
      name: string;
      addressLines: Array<string>;
      locality: string;
      region: string;
      postcode: string;
      countryId: string;
      siteAccountNumber: string;
    },
    id: number,
  ): Promise<Record<string, unknown>> {
    return axios.patch(`${window.location.protocol}//${window.location.host}/api/v1/sites/${id}`, { payload: updatedSite }).then((res) => ({ ...res.data }));
  }

  static getAddTemplate(locale: string): Promise<Record<string, unknown>> {
    return axios.get(`${window.location.protocol}//${window.location.host}/api/v1/templates/sites/add`, {
      // responseType: 'arraybuffer',
      params: {
        locale: locale,
      },
      headers: {
        'Content-Type': 'application/json',
      },
    });
  }

  static async postAddTemplate(file: File): Promise<Record<string, unknown>> {
    const fileString = await convertFileToB64(file);

    return axios.post(
      `${window.location.protocol}//${window.location.host}/api/v1/templates/sites/add`,
      { payload: fileString },
      {
        headers: {
          'Content-Type': 'application/json',
        },
      },
    );
  }

  add(): Promise<Record<string, unknown>> {
    return axios
      .post(`${window.location.protocol}//${window.location.host}/api/v1/sites`, {
        payload: this,
      })
      .then((res) => ({ ...res.data }));
  }
}
